module.exports = __webpack_public_path__ + "static/media/intro-video-bottom.d7532899.svg";